/**
 * Shared behaviour for form components
 *
 * @mixin form
 */
export default {
  props: {
    /**
     * Value is an object with a property to match each form field. We treat
     * forms as vue input components which are bound to this object so that 2
     * way data binding is possible for form data.
     */
    value: {
      type: Object,
      default: () => {return {}}
    },

    /**
     * For passing in validation errors from other sources (usually server side
     * validation errors)
     */
    errors: {
      type: Object,
      default: () => {return {}}
    }
  },

  computed: {
    /**
     * Always use this.resource to acces this.value from within forms
     */
    resource: {
      get() {
        return this.value
      },

      /**
       * Emit input events whenever form fields are changed. This allows for
       * v-model to be used on form components.
       */
      set(newValue) {
        this.$emit('input', newValue)
      }
    },

    /**
     * component errorClass
     *
     * @returns {string} classname
     */
    errorClass() {
      return {'is-invalid': this.error}
    },

    /**
     * Is form data invalid?
     *
     * @returns {boolean}
     */
    isInvalid() {
      return this.$v.$invalid
    },

    /**
     * Is form data valid?
     *
     * @returns {boolean}
     */
    isValid() {
      return !this.isInvalid
    }
  },

  methods: {
    /**
     * Run validation and emit a submit event if validation passes
     */
    submit() {
      this.$v.$touch()

      if(this.isValid) {
        this.$emit('submit', this.value)
      }
    },

    /**
     * Mark a form field as dirty for use in browserside validation
     *
     * @param {string} name - property name to be touched
     */
    touch(name) {
      //TODO: Choosing cyl from dropdown breaks here!
      this.$v.resource[name].$touch()
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/mixins/form.js
// module id = null
// module chunks = 